import { render, staticRenderFns } from "./ranking-category.vue?vue&type=template&id=1691c0ed&scoped=true&"
import script from "./ranking-category.vue?vue&type=script&lang=js&"
export * from "./ranking-category.vue?vue&type=script&lang=js&"
import style0 from "./ranking-category.vue?vue&type=style&index=0&id=1691c0ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691c0ed",
  null
  
)

export default component.exports